enum RegisterMode {
  Register,
  RegisterSuccess,
}

export default RegisterMode;
